// Section 22 Settings: persisted under a namespaced localStorage key (24.12).
import { readSettings, resizeRing, writeSettings, type Settings } from '../../persist';
import { refreshSaves } from '../session';
import { patchUi, settings } from '../state';
import { currentStorage } from '../storage';

/** Load settings and the saves index from storage (app start, tests). */
export function initStore(): void {
  settings.value = readSettings(currentStorage());
  refreshSaves();
}

export function setSettings(patch: Partial<Settings>): void {
  const before = settings.value;
  const next = { ...before, ...patch };
  settings.value = next;
  const storage = currentStorage();
  if (!writeSettings(storage, next)) patchUi({ notice: { code: 'storage-unavailable', detail: null } });
  if (storage !== null && next.autosaveCount < before.autosaveCount) {
    resizeRing(storage, next.autosaveCount);
    refreshSaves();
  }
}
